module.exports = __webpack_public_path__ + "static/img/Bachelor_010693.d326715.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010693.jpg
// module id = 219
// module chunks = 0